import {IconType} from '../components/icons';

export interface Entity {
  id: string;
  type?: string
}

export class EntityModel<T extends Entity> {
  readonly type?: string
  readonly id: string;
  readonly icon?: IconType

  constructor(source: T, icon?: IconType) {
    this.id = source.id
    this.type = source.type
    this.icon = icon
  }
}

export type CreateEntity<T extends Entity> = Exclude<Partial<T>, 'id' | 'created_at' | 'updated_at'>;
export type UpdateEntity<T extends Entity> = CreateEntity<T> & Pick<T, 'id'>;
export type EntityId = {id: string} | string

export interface PagedList<T extends Entity> {
  count: number;
  page: number;
  pages: number;
  items: T[]
}

export function parseDate(date: string | undefined | null): Date | undefined {
  return date ? new Date(date) : undefined;
}

export function isEntityId(what: any): what is EntityId {
  return (typeof what === 'string') || (typeof what === 'object' && 'id' in what)
}

export function entityId(id: EntityId | undefined): string | undefined {
  if (!id) return undefined
  if (typeof id === 'string') return id
  return id.id;
}

export const EMPTY_LIST: PagedList<any> = Object.freeze({ count: 0, page: 0, pages: 0, items: [] })
